import React from 'react';
import {
    Filters,
    TextStyle,
    Stack,
    Checkbox,
    RangeSlider,
    Button
} from '@shopify/polaris';
import { GenieTag } from './GenieTag';

function compare(a, b) {
    const bandA = a.tagName.toUpperCase();
    const bandB = b.tagName.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }

    return comparison;
}

function compare2(a, b) {

    const bandA = a.tagGroup;
    const bandB = b.tagGroup;

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }

    return comparison;
}

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

function disambiguateLabel(key, value) {
    switch (key) {
        case 'tagNameFilter':
            return `Tagged with ${value}`;
        default:
            return value;
    }
}

class TagViewComponent extends React.Component {

    constructor(props) {
        super(props)

        // TODO: handle prop updates
        this.state = {
            tagNameFilter: null,
            queryValue: null,
            selectedTags: props.selectedTags,
            highlight: false,
            highlightResourceCount: 1,
            orderByGroups: props.orderByGroups,
            filterWithGroups: props.filterWithGroups,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedTags.length !== this.props.selectedTags.length) {
            this.setState({ selectedTags: this.props.selectedTags });
        }
    }

    getFilterControl = () => {

        let tagNameFilter = this.state.tagNameFilter;
        let queryValue = this.state.queryValue;

        const filters = [];
        const appliedFilters = !isEmpty(tagNameFilter)
            ? [
                {
                    key: 'tagNameFilter',
                    label: disambiguateLabel('tagNameFilter', tagNameFilter),
                    onRemove: this.handleTagNameFilterRemove,
                },
            ]
            : [];

        return <Filters
            focused={true}
            queryValue={queryValue}
            queryPlaceholder="Filter tags"
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={this.setQueryValue}
            onQueryClear={this.handleQueryValueRemove}
            onQueryBlur={this.handleQueryBlur}
            onClearAll={this.handleClearAll}>
        </Filters>
    }

    onMarkUnmarkListed = () => {

        let newSelected = [...this.state.selectedTags];
        let listedTagNames = this.props.tags
            .filter(tag => this.state.queryValue == null || tag.tagName.toUpperCase().includes(this.state.queryValue.toUpperCase()))
            .map((tag) => tag.tagName);

        listedTagNames.forEach(element => {
            newSelected = this.getSelectedAfterToggle(newSelected, element);
        });

        this.setState({
            selectedTags: newSelected
        });

        this.props.onSelectedChange(newSelected);
    }

    onTagClick = (tagName) => {

        if (!this.props.canSelect) {
            return;
        }

        let newSelectedTags = this.getSelectedAfterToggle([...this.state.selectedTags], tagName);

        this.setState({
            selectedTags: newSelectedTags
        });

        this.props.onSelectedChange(newSelectedTags);
    }

    getSelectedAfterToggle = (selectedTags, tagName) => {
        let isRemoved = selectedTags.includes(tagName);
        let newSelectedTags = [tagName, ...selectedTags];

        if (isRemoved) {
            let tagIndex = selectedTags.indexOf(tagName);
            newSelectedTags = [...selectedTags.slice(0, tagIndex), ...selectedTags.slice(tagIndex + 1)];
        }

        return newSelectedTags;
    }

    render() {

        let filter = this.getFilterControl();
        let clickHandler = this.onTagClick;
        if (!this.props.canSelect) {
            clickHandler = null;
        }
        var orderFunc = this.state.orderByGroups ? compare2 : compare;

        let tagItems = this.props.tags
            .filter(tag => (!this.state.filterWithGroups || (this.state.filterWithGroups && tag.tagGroup === "#_Unassigned")) && (this.state.queryValue == null || tag.tagName.toUpperCase().includes(this.state.queryValue.toUpperCase())))
            .sort(orderFunc).map((tag) => {
                let isMarked = this.state.selectedTags.includes(tag.tagName);
                let state = isMarked ? this.props.selectedTagsState : "default";
                let highlighted = this.state.highlight && tag.resourceCount <= this.state.highlightResourceCount;
                return <GenieTag key={tag.tagName} backgroundColor={this.state.orderByGroups ? tag.tagColor : null} onClick={clickHandler} highlighted={highlighted} state={state} selected={isMarked}>{tag.tagName}</GenieTag>
            });

        let rangeSlider = <RangeSlider
            step={1}
            min={1}
            max={5}
            value={this.state.highlightResourceCount}
            onChange={this.handleRangeSliderChange}
            output
        />;

        let highlightLabel = `Highlight rarely-used tags with ${this.state.highlightResourceCount} or less products`
        let highlight = <div><Stack alignment="center" distribution="leading" spacing="tight"><Checkbox label={highlightLabel}
            checked={this.state.highlight}
            onChange={this.handleHighlightChange}
        /> {this.state.highlight && rangeSlider} </Stack></div>

        let group = <div>
            <Stack alignment="center" distribution="leading" spacing="tight">
                {this.props.showOrderByGroups && <Checkbox label="Order by tag groups with colors"
                    checked={this.state.orderByGroups}
                    onChange={() => this.setState({ orderByGroups: !this.state.orderByGroups })}
                />}
                {this.props.showFilterWithGroups && <Checkbox label="Only show tags without groups"
                    checked={this.state.filterWithGroups}
                    onChange={() => this.setState({ filterWithGroups: !this.state.filterWithGroups })}
                />}
            </Stack>
        </div>

        return (
            <div className="tagView">
                <Stack distribution="leading" spacing="tight">
                    {this.props.showFilter && <Stack.Item fill>
                        {filter}
                    </Stack.Item>
                    }
                    {this.props.showMarkUnmark && <Stack.Item>
                        <Button onClick={this.onMarkUnmarkListed}>Mark/Unmark listed</Button>
                    </Stack.Item>}
                </Stack>
                {this.props.showHighlight && highlight }
                {group}
                <br></br>
                <div><Stack spacing="tight" distribution="leading" alignment="leading">{tagItems}</Stack></div>
                <br></br>
                {this.props.canSelect && <TextStyle variation="subdued">{this.props.tagActionText}</TextStyle>}
            </div>
        );
    }

    setQueryValue = (value) => {
        this.setState({ queryValue: value });
    }

    handleHighlightChange = (value) => {
        this.setState({ highlight: value });
    }

    handleRangeSliderChange = (value) => {
        this.setState({ highlightResourceCount: value });
    }

    handleQueryValueRemove = () => {
        this.setState({ queryValue: null });
    }

    handleQueryBlur = () => {
    }

    handleClearAll = () => {
        this.setState({ tagNameFilter: null, queryValue: null });
    }

    handleTagNameFilterRemove = () => {
        this.setState({ tagNameFilter: null });
    }

    componentDidMount() {
    }
}

TagViewComponent.defaultProps = {
    onSelectedChange: () => { },
    tagActionText: "Click on a tag to select it.",
    canSelect: false,
    showFilter: true,
    showHighlight: true,
    tags: [],
    selectedTags: [],
    selectedTagsState: "default",
    orderByGroups: false,
    showOrderByGroups: false,
    filterWithGroups: false,
    showFilterWithGroups: false
}

export default TagViewComponent;